"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cell = void 0;

var _style = _interopRequireDefault(require("styled-jsx/style"));

var React = _interopRequireWildcard(require("react"));
/** @component */


var Cell = function Cell(props) {
  var children = props.children;
  return React.createElement("div", {
    className: "jsx-1916302332" + " " + "cell ".concat(props.isSelected ? "focused" : "", " ").concat(props._hovered ? "overrideHover" : "")
  }, React.createElement(_style["default"], {
    styleId: "1916302332",
    css: ".cell.jsx-1916302332{position:relative;background:var(--theme-cell-bg,white);-webkit-transition:all 0.1s ease-in-out;transition:all 0.1s ease-in-out;}.cell.overrideHover.jsx-1916302332,.cell.jsx-1916302332:hover{box-shadow:var( --theme-cell-shadow-hover, 1px 1px 3px rgba(0,0,0,0.12), -1px -1px 3px rgba(0,0,0,0.12) );}.cell.focused.jsx-1916302332{box-shadow:var( --theme-cell-shadow-focus, 3px 3px 9px rgba(0,0,0,0.12), -3px -3px 9px rgba(0,0,0,0.12) );}.cell.overrideHover.jsx-1916302332 .prompt,.cell.jsx-1916302332:hover .prompt,.cell.jsx-1916302332:active .prompt{background-color:var(--theme-cell-prompt-bg-hover,hsl(0,0%,94%));color:var(--theme-cell-prompt-fg-hover,hsl(0,0%,15%));}.cell.jsx-1916302332:focus .prompt,.cell.focused.jsx-1916302332 .prompt{background-color:var(--theme-cell-prompt-bg-focus,hsl(0,0%,90%));color:var(--theme-cell-prompt-fg-focus,hsl(0,0%,51%));}.cell.focused.jsx-1916302332 .outputs{overflow-y:auto;}"
  }), children);
};

exports.Cell = Cell;
Cell.defaultProps = {
  isSelected: false,
  _hovered: false,
  children: null
};